export default function parseTime(str) {
  const parsed = Date.parse(str)
  const date = new Date(parsed)
  const hours = date.getHours()
  let minutes = date.getMinutes()

  if (String(minutes).length === 1) {
    minutes = `0${minutes}`
  }

  return `${hours}:${minutes}`
}



// WEBPACK FOOTER //
// ./src/helpers/parseTime.js